import {
  GET_FAQS_FAIL,
  GET_FAQS_SUCCESS,
  GET_CATEGORIES_FAIL,
  GET_CATEGORIES_SUCCESS,
  ADD_FAQ_SUCCESS,
  ADD_FAQ_FAIL,
  UPDATE_FAQ_SUCCESS,
  UPDATE_FAQ_FAIL,
  DELETE_FAQ_SUCCESS,
  RESET_FAQ_FLAG,
  DELETE_FAQ_FAIL,
  STATUS_CHANGE_FAQ_SUCCESS,
  STATUS_CHANGE_FAQ_FAIL,
  FEATURED_CHANGE_FAQ_SUCCESS,
  FEATURED_CHANGE_FAQ_FAIL,
  MODIFY_FAQ_FLAG,
  SAVE_ORDERING_FAQ_SUCCESS,
  SAVE_ORDERING_FAQ_FAIL,
  SAVE_ORDERING_FAQ_RESET_FLAG,
  GET_FAQ_DETAILS_SUCCESS,
  GET_FAQ_DETAILS_FAIL,
} from "./actionType";

const INIT_STATE = {
  faqs: [],
  categories: [],
  error: {},
  loading: true
};

const Faq = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_FAQS_SUCCESS:
      return {
        ...state,
        faqs: action.payload.data,
        totalDataCount: action.payload.count,
        isSuccess: true,
        loading: false
      };

    case GET_FAQS_FAIL:
      return {
        ...state,
        error: action.payload.message,
        totalDataCount: 0,
        isSuccess: false,
        loading: false
      };

    case ADD_FAQ_SUCCESS:
      return {
        ...state,
        faqs: [...state.faqs, action.payload.data],
        success: action.payload.message,
        isFaqAdd: true,
        isFaqAddFail: false,
      };

    case ADD_FAQ_FAIL:
      return {
        ...state,
        error: action.payload.message,
        isFaqAdd: false,
        isFaqAddFail: true,
      };

    case UPDATE_FAQ_SUCCESS:
      return {
        ...state,
        faqs: state.faqs.map((faq) =>
          faq._id.toString() === action.payload.data._id.toString()
            ? { faq, ...action.payload.data }
            : faq
        ),
        success: action.payload.message,
        isFaqUpdate: true,
        isFaqUpdateFail: false,
      };

    case UPDATE_FAQ_FAIL:
      return {
        ...state,
        error: action.payload.message,
        isFaqUpdate: false,
        isFaqUpdateFail: true,
      };

    case GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        categories: action.payload,
      };

    case GET_CATEGORIES_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case MODIFY_FAQ_FLAG:
      return {
        ...state,
        statusSuccess: false,
      };

    case RESET_FAQ_FLAG:
      return {
        ...state,
        isFaqAdd: false,
        isFaqAddFail: false,
        isSuccess: false,
        isFaqDetails: false,
        isFaqUpdate: false,
        isFaqUpdateFail: false,
        error: false,
      };

    case GET_FAQ_DETAILS_SUCCESS:
      return {
        ...state,
        details: action.payload.data,
        isSuccess: true,
      };
    case GET_FAQ_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload.message,
      };

    // Status Change
    case STATUS_CHANGE_FAQ_SUCCESS:
      return {
        ...state,
        faqs: state.faqs.map((faq) =>
          action.payload.faqs.id.includes(faq._id)
            ? { ...faq, status: action.payload.faqs.column_value }
            : faq
        ),
        success: action.payload.message,
        statusSuccess: true,
        statusFailed: false,
      };

    case STATUS_CHANGE_FAQ_FAIL:
      return {
        ...state,
        error: action.payload.message,
        statusSuccess: false,
        statusFailed: true,
      };

    // Feature Change
    case FEATURED_CHANGE_FAQ_SUCCESS:
      return {
        ...state,
        faqs: state.faqs.map((faq) =>
          action.payload.faqs.id.includes(faq._id)
            ? { ...faq, featured: action.payload.faqs.column_value }
            : faq
        ),
        success: action.payload.message,
        featuredSuccess: true,
        featuredFailed: false,
      };

    case FEATURED_CHANGE_FAQ_FAIL:
      return {
        ...state,
        error: action.payload.message,
        featuredSuccess: false,
        featuredFailed: true,
      };

    //Save Ordering
    case SAVE_ORDERING_FAQ_SUCCESS:
      return {
        ...state,
        success: action.payload.message,
        saveOrderingSuccess: true,
        saveOrderingFaild: false,
      };

    case SAVE_ORDERING_FAQ_FAIL:
      return {
        ...state,
        error: action.payload.message,
        saveOrderingSuccess: false,
        saveOrderingFaild: true,
      };

    //Save Ordering reset flag
    case SAVE_ORDERING_FAQ_RESET_FLAG:
      return {
        ...state,
        saveOrderingSuccess: false,
        saveOrderingFaild: false,
        error: false,
      };

    //Delete

    case DELETE_FAQ_SUCCESS:
      return {
        ...state,
        faqs: state.faqs.filter((faq) => {
          return !action.payload.data.includes(faq._id);
        }),
        success: action.payload.message,
        isSuccess: true,
        statusSuccess: true,
        statusFailed: false,
        isFaqRemove: true,
        isFaqRemoveFail: false,
      };

    case DELETE_FAQ_FAIL:
      return {
        ...state,
        error: action.payload.message,
        isSuccess: false,
        statusSuccess: false,
        statusFailed: true,
        isFaqRemove: false,
        isFaqRemoveFail: true,
      };

    default:
      return state;
  }
};

export default Faq;
